<tp-page-scaffold [pageAvailability]="availability$ | async">
  @if (!reauthRequired) {
    <div class="scroll-box" (scroll)="checkScrollLocation($event)">
      <div class="tp-bento-box subtle notif-bar">
        <h3>Security center</h3>
        <p>View security recommendations and manage your team's security settings</p>
      </div>

      <div class="drawer-container">
        <div class="drawer-content">
          <div class="drawer-section">
            <a [class.active]="this.activeSection === 'overview'" routerLink="./overview">Overview</a>
            <a [class.active]="currentActive === 'score'" routerLink="./overview" fragment="score">Security score</a>
            <a [class.active]="currentActive === 'recommendations'" routerLink="./overview" fragment="recommendations">Security recommendations</a>
          </div>
          <div class="drawer-section">
            <a [class.active]="this.activeSection === 'config'" routerLink="./config">Configuration</a>
            <a [class.active]="currentActive === 'mfa-policy'" routerLink="./config" fragment="mfa-policy">MFA enforcement</a>
            <a [class.active]="currentActive === 'team-admins'" routerLink="./config" fragment="team-admins">Team admins</a>
            <a [class.active]="currentActive === 'security-contacts'" routerLink="./config" fragment="security-contacts">Security contacts</a>
          </div>
        </div>

        <article>
          <router-outlet/>
        </article>
      </div>
    </div>
  } @else {
    <div class="tp-bento-box subtle notif-bar">
      <h3>Reauthentication required</h3>
      <p>For security reasons, you must reauthenticate before accessing the security center</p>
      <div class="notif-buttons">
        <tp-button [height]="32" buttonStyle="primary-outline green stroke" (click)="openReauthDialog()" buttonId="reauthenticate">
          Reauthenticate
        </tp-button>
      </div>
    </div>
  }
</tp-page-scaffold>
